var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeploymentSchedulerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.875 10C27.9105 10 28.75 10.8395 28.75 11.875L28.75 25H41.875C42.9105 25 43.75 25.8395 43.75 26.875C43.75 27.9105 42.9105 28.75 41.875 28.75H26.875C25.8395 28.75 25 27.9105 25 26.875L25 11.875C25 10.8395 25.8395 10 26.875 10Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.875 3.75C14.1034 3.75 3.75 14.1034 3.75 26.875C3.75 39.6466 14.1034 50 26.875 50C39.6466 50 50 39.6466 50 26.875C50 14.1034 39.6466 3.75 26.875 3.75ZM0 26.875C0 12.0323 12.0323 0 26.875 0C41.7177 0 53.75 12.0323 53.75 26.875C53.75 41.7177 41.7177 53.75 26.875 53.75C12.0323 53.75 0 41.7177 0 26.875Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploymentSchedulerIcon);
export default __webpack_public_path__ + "static/media/Deployment-Scheduler-icon.6997e9e57907c09d206d9cfcbe110ba6.svg";
export { ForwardRef as ReactComponent };